import React from 'react';
import { Link } from 'react-router-dom';

const QuickActionCard = ({ to, icon, label, description, external = false }) => {
  const inner = (
    <div className="flex flex-col items-center justify-center p-3 bg-white dark:bg-gray-800 rounded-2xl shadow-card active:scale-[0.97] transition-transform duration-150 min-h-[100px]">
      <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center mb-2 text-primary">
        {icon}
      </div>
      <span className="text-xs font-semibold text-gray-900 dark:text-white text-center leading-tight">
        {label}
      </span>
      {description && (
        <span className="text-[10px] text-gray-400 text-center mt-0.5 leading-tight">
          {description}
        </span>
      )}
    </div>
  );

  if (external) {
    return <a href={to} target="_blank" rel="noopener noreferrer">{inner}</a>;
  }
  return <Link to={to}>{inner}</Link>;
};

export default QuickActionCard;
